// extracted by mini-css-extract-plugin
export var button = "download-block-module--button--5d1a5";
export var link = "download-block-module--link--d2974";
export var nameWrapper = "download-block-module--name-wrapper--d31be";
export var wrapper = "download-block-module--wrapper--fffd7";